export const LessIsMore = () => {
  const rows = [
    { d: "gmail.com", c: 5 },
    { d: "mail.com", c: 4 },
    { d: "hey.com", c: 3 },
    { d: "pm.me", c: 2 },
    { d: "w.xyz", c: 1 },
  ];

  return (
    <section
      id="less-is-more"
      data-testid="less-is-more-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="font-serif-display text-pearl text-3xl sm:text-5xl tracking-tight leading-[1.05]">
            The <span className="italic text-bone">Shortest</span> Email Domain.
          </h2>
        </div>

        <div
          data-testid="hero-domain-ladder"
          className="mx-auto max-w-sm"
        >
          <div className="flex items-baseline justify-between mb-2 px-1">
            <span className="label-overline text-ash/50">Domain</span>
            <span className="label-overline text-ash/50">Letters</span>
          </div>
          <ul className="space-y-0">
            {rows.map(({ d, c }) => (
              <li
                key={d}
                data-testid={`domain-row-${d}`}
                className="flex items-center justify-between border-t border-[var(--w-border)] py-2.5 px-1"
              >
                <span className="font-mono-label text-[14px] text-ash">
                  @{d}
                </span>
                <span className="font-mono-label text-[12px] tabular-nums text-ash/60">
                  {c}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default LessIsMore;
